import { DateRange, IconImage } from 'bold-ui'
import { blue, ColorScale, green, red, turquoise, yellow } from 'bold-ui/lib/styles/colors'
import { EquipeSelectModel, UnidadeSaudeSelectModel } from 'components/form'
import { LotacoesComRegulacoesSelectFieldModel } from 'components/form/field/select/LotacoesComRegulacoesSelectField/LotacoesComRegulacoesSelectField'
import { Color } from 'csstype'
import {
  HistoricoRegulacaoEvolucaoQuery,
  ListaRegulacaoQuery,
  OrdemRegulacaoEnum,
  PageParams,
  PrioridadeRegulacaoEnum,
  StatusRegulacaoEnum,
  TipoRegulacaoEnum,
} from 'graphql/types.generated'

export type ListaRegulacaoTableItem = ListaRegulacaoQuery['listaRegulacao']['content'][0]
export type RegulacaoEvolucaoModel = HistoricoRegulacaoEvolucaoQuery['evolucoesRegulacao'][0]

export interface ListaRegulacaoFilterModel {
  tableFilter: ListaRegulacaoTableFilterModel
  pageParams: PageParams
}

export interface ListaRegulacaoTableFilterModel
  extends ListaRegulacaoTableFilterInlineModel,
    ListaRegulacaoTableFilterPopperModel {
  tipoRegulacao: TipoRegulacaoEnum[]
  statusRegulacao: StatusRegulacaoEnum[]
  equipe: EquipeSelectModel
  unidadeSaude: UnidadeSaudeSelectModel
}

export interface ListaRegulacaoTableFilterInlineModel {
  ordem: OrdemRegulacaoEnum
  nomeCnsCpf: string
  isSomenteMeusAtendimentos: boolean
}

export interface ListaRegulacaoTableFilterPopperModel {
  solicitantes: LotacoesComRegulacoesSelectFieldModel[]
  periodo: DateRange
}

export type StatusRegulacaoEnumRecord = {
  icon?: IconImage
  svgIcon?: React.ReactElement
  mainColor?: Color
  colorScale?: ColorScale
}

export const LISTA_REGULACAO_DEFAULT_FILTERS: ListaRegulacaoFilterModel = {
  tableFilter: {
    tipoRegulacao: [],
    statusRegulacao: [],
    equipe: undefined,
    unidadeSaude: undefined,
    ordem: OrdemRegulacaoEnum.ATUALIZACOES_REGULACAO_MAIS_RECENTES,
    nomeCnsCpf: '',
    isSomenteMeusAtendimentos: false,
    periodo: null,
    solicitantes: [],
  },
  pageParams: {
    size: 10,
  },
}

export const RegulacaoEnumTextMap: Record<StatusRegulacaoEnum | TipoRegulacaoEnum, string> = {
  SOLICITADA: 'Solicitada',
  PENDENTE_DE_AGENDAMENTO: 'Pendente de Agendamento',
  PENDENTE_DE_REGULACAO: 'Pendente de Regulação',
  DEVOLVIDO_PELA_REGULACAO: 'Devolvido pela Regulação',
  ATENDIMENTO_AGENDADO: 'Atendimento Agendado',
  AGENDAMENTO_CONFIRMADO: 'Agendamento Confirmado',
  AGENDAMENTO_COM_FALTA: 'Agendamento com Falta',
  SOLICITACAO_CANCELADA: 'Solicitação Cancelada',
  AGENDAMENTO_CANCELADO: 'Agendamento Cancelado',
  NEGADA_PELA_REGULACAO: 'Negada pela Regulação',
  SOLICITACAO_EXAME_COMUM: 'Exame comum',
  SOLICITACAO_EXAME_ALTO_CUSTO: 'Exame de alto custo',
  GUIA_ENCAMINHAMENTO: 'Guia de encaminhamento',
  SOLICITACAO_EXAME_OCI: 'OCI',
}

export const regulacaoClassificacaoPrioridadeRecord: Record<
  PrioridadeRegulacaoEnum,
  { label: string; mainColor: Color | null }
> = {
  [PrioridadeRegulacaoEnum.NAO_INFORMADA]: {
    label: 'Não informada',
    mainColor: null,
  },
  [PrioridadeRegulacaoEnum.NAO_URGENTE]: {
    label: 'Não urgente',
    mainColor: turquoise.c60,
  },
  [PrioridadeRegulacaoEnum.BAIXA]: {
    label: 'Baixa',
    mainColor: blue.c40,
  },
  [PrioridadeRegulacaoEnum.MEDIA]: {
    label: 'Média',
    mainColor: green.c40,
  },
  [PrioridadeRegulacaoEnum.ALTA]: {
    label: 'Alta',
    mainColor: yellow.c60,
  },
  [PrioridadeRegulacaoEnum.MUITO_ALTA]: {
    label: 'Muito alta',
    mainColor: red.c40,
  },
}
